import React from "react"

const TitleBox = ({ children, className }) => {
  return (
    <h1
      className={`text-center bg-blue-dark  leading-none pt-8 pb-5 px-5 text-white rounded shadow-md ${className}`}
    >
      {children}
    </h1>
  )
}

export default TitleBox
